import React from 'react';
import { Navigate } from 'react-router-dom';
import NotFoundPage from '../pages/NotFoundPage';
import SessionTimeoutDialog from "../components/ui/SessionTimeoutDialog/SessionTimeoutDialog";

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRole?: string[];
  requiredPermissions?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  requiredRole = [],
  requiredPermissions = [],
}) => {
  // Obtener perfil y permisos del usuario
  let userProfile: { role?: string } = {};
  let userPermissions: string[] = [];

  try {
    userProfile = JSON.parse(localStorage.getItem('userProfile') || '{}');
    userPermissions = JSON.parse(localStorage.getItem('userPermissions') || '[]');
  } catch (error) {
    console.error("Error parsing localStorage", error);
  }

  const role = userProfile.role;
  const isAuthenticated = !!role;

  const hasRequiredRole = requiredRole.length === 0 || requiredRole.includes(role || '');
  const hasRequiredPermissions =
    requiredPermissions.length === 0 ||
    requiredPermissions.every(p => userPermissions.includes(p));

  console.log("User Role:", role);
  console.log("User Permissions:", userPermissions);
  console.log("Required Role:", requiredRole);
  console.log("Required Permissions:", requiredPermissions);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!hasRequiredRole || !hasRequiredPermissions) {
  console.log("Has Required Role:", hasRequiredRole);
  console.log("Has Required Permissions:", hasRequiredPermissions);
    return <NotFoundPage />;
  }

   return (
    <>
      <SessionTimeoutDialog />
      {children}
    </>
  );
};

export default PrivateRoute;
